import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiResponseModalSliceDispatch, reducerDispatch } from "../../Constants/ReduxConstants";

interface RootState {
    refreshLoadedFile: { isLoading: boolean };
    pickAFile: { fileLength: number | null };
}

const CloseFile: React.FC = () => {
    const isLoading = useSelector((state: RootState) => state.refreshLoadedFile.isLoading);
    const currentFileLength = useSelector((state: RootState) => state.pickAFile.fileLength);

    const dispatch = useDispatch();

    return (
        <button 
            disabled={currentFileLength == null || isLoading} 
            onClick={() => {
                dispatch({ type: reducerDispatch.resetState });
                dispatch({ type: apiResponseModalSliceDispatch.setOpenedFileFromApi, payload: false });
            }} 
            title="Close File Without Saving"
        >
            Close File Without Saving
        </button>
    );
};

export default CloseFile;